//@flow
import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import {TRIGGER_FIELDS} from '../../const';
import CustomTextEditor from '../../../../../../../elements/CustomTextEditor/CustomTextEditor';
import {Typography, makeStyles} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';
import {getFormError} from '../../../../utils/formErrors';
import AttachmentPreview from './Attachments';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  subtitle: {
    fontSize: '14px',
    color: colors.grey800,
  },
  fieldError: {
    fontSize: '.8125rem',
    color: colors.danger,
  },
}));

export default function ResponseSection() {
  const classes = useStyles();

  const {register, setValue, watch, errors} = useFormContext();
  const responseError = getFormError(errors, TRIGGER_FIELDS.response);

  useEffect(() => {
    // Validation is driven by validateTriggerForm — avoid RHF `required` on
    // setValue/reset fields (false invalid + empty messages on edit save).
    register(TRIGGER_FIELDS.response);
  }, [register]);

  const watchResponse = watch(TRIGGER_FIELDS.response);

  return (
    <div className={classes.root}>
      <CustomTextEditor
        onChange={value => {
          setValue(TRIGGER_FIELDS.response, value, {
            shouldDirty: true,
            shouldValidate: true,
          });
        }}
        text={watchResponse}
      />

      {responseError && (
        <Typography className={classes.fieldError}>{responseError}</Typography>
      )}

      <Typography className={classes.subtitle}>
        Archivos adjuntos. (Imagenes, videos, o documentos) maximo 10 archivos
      </Typography>
      <AttachmentPreview />
    </div>
  );
}
